import { Box, Card, Container, Grid, Step, StepButton, Stepper, Typography } from '@material-ui/core';
import { menusService, statisticsService } from 'core/services';
import React, { useEffect, useState } from 'react';
import { useStatisticsContext } from '../contexts/StatistiquesProvider';
import ChoixAdhesion from './ChoixAdhesion';
import PyramideAge from './PyramideAge';
import TableEffectifsMoyens from './TableEffectifsMoyens';
//import FraisReels from './FraisReels';
import { yupResolver } from '@hookform/resolvers/yup';
import { OptionType, SGSButton, SGSForm } from 'components';
import { FormPerimetre } from 'features/utilisateurs/components/form/formPerimetre';
import { useUserPerimetreContext } from 'features/utilisateurs/contexts/UtilisateurPerimetreProvider';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import EffectifEnPortabilite from './EffectifEnPortabilite';
//import styles from '../../utilisateurs/components/Utilisateurs.module.scss';
import { Alert } from '@material-ui/lab';
import { useAppContext } from 'core/contexts';
import { format } from 'date-fns';
import { delay } from 'lodash';
import { useQuery } from 'react-query';

const useQueryConf = {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 5,
};

type Props = {};

const Dashboard: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { user } = useAppContext();
    const steps = ['Paramétrage du rapport', 'Rapport statistiques'];
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = useState<{
        [k: number]: boolean;
    }>({});
    const {
        setPyramidAge,
        setIsLoadingPyramidAge,
        setEffectifsMoyens,
        setIsLoadingEffectifsMoyens,
        setIsLoadingChoixAdhesion,
        setChoixAdhesion,
        // setIsLoadingFraisReels,
        // setFraisReels,
        setIsLoadingEffectifEnPortabilite,
        setEffectifEnPortabilite,
        isFormSubmitted,
        setIsFormSubmitted,
    } = useStatisticsContext();
    const { setLoadingPerimetre, setHasPerimetreErreur, setPerimetre, setSante, setPrevoyance, setSelectedColleges, setSelectedSouscrips } = useUserPerimetreContext();

    const handlePyramidAge = (data) => {
        setPyramidAge(data);
        setIsLoadingPyramidAge(false);
    };

    const handleEffectifMoyen = (data) => {
        setEffectifsMoyens(data);
        setIsLoadingEffectifsMoyens(false);
    };

    const handleChoixAdhesion = (data) => {
        setChoixAdhesion(data);
        setIsLoadingChoixAdhesion(false);
    };

    // const handleFraisReels = (data) => {
    //     setFraisReels(data);
    //     setIsLoadingFraisReels(false);
    // };

    const handleEffectifEnPortabilite = (data) => {
        setEffectifEnPortabilite(data);
        setIsLoadingEffectifEnPortabilite(false);
    };

    // STEPPER
    const scrollTop = () => {
        window.scrollTo(0, 0);
    };

    const handleStep = (step: number) => async () => {
        if (step === 0) {
            const resetCompleted = { ...completed };
            resetCompleted[0] = false;
            resetCompleted[1] = false;
            setCompleted(resetCompleted);
        }
        setActiveStep(step);
        scrollTop();
    };

    const newRapport = () => {
        setIsFormSubmitted(false);
        setCompleted({});
        initFormControlled(initStatsForm);
    };

    const handleBack = () => {
        newRapport();
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = async () => {
        const isValid = await validateStep(activeStep);
        if (!isValid) return;
        setActiveStep(activeStep + 1);
        scrollTop();
    };

    const handleComplete = async () => {
        // validate Login on step 1 change
        const newCompleted = completed;
        newCompleted[activeStep + 1] = true;
        setCompleted(newCompleted);
        delay(handleNext, 20);
    };

    const validateStep = async (activeStep) => {
        const validate = (result) => {
            if (result) {
                const newCompleted = completed;
                newCompleted[activeStep] = true;
                setCompleted(newCompleted);
            } else {
                const newCompleted = { ...completed };
                newCompleted[activeStep] = false;
                setCompleted(newCompleted);
            }
        };

        let result = false;
        switch (activeStep) {
            case 0:
                result = await trigger(['perimetre', 'dateArrete']);
                validate(result);
                break;
            default:
                throw Error('Step validation is missing');
        }

        return result;
    };

    const handleFormCancel = () => {
        initFormControlled({ ...initStatsForm });
    };

    /** API  */

    //* Load data
    const { isLoading, data, error } = useQuery([user.login, 'perimetre'], async () => await menusService.getMenuPerimetre(), useQueryConf);

    useEffect(() => {
        setLoadingPerimetre(isLoading);
    }, [isLoading, setLoadingPerimetre]);

    useEffect(() => {
        // Ensure data exists and is an array before filtering
        if (Array.isArray(data)) {
            // Filter out items with college !== 'RETRAITE'
            const filteredData = data.filter((d) => d.college !== 'RETRAITE');
            // Update the perimetre state with the filtered data
            setPerimetre(filteredData);
        }
    }, [data, setPerimetre]);

    useEffect(() => {
        if (error) setHasPerimetreErreur(true);
        else setHasPerimetreErreur(false);
    }, [error, setHasPerimetreErreur]);

    /** FORM VALIDATION */
    type StatsForm = {
        dateArrete: string;
        perimetre: {
            risques: { sante: boolean; prevoyance: boolean };
            souscripteurs: OptionType[];
            colleges: OptionType[];
        };
    };

    const validationSchema: Yup.SchemaOf<StatsForm> = Yup.object().shape({
        dateArrete: Yup.string().required(),
        perimetre: Yup.object().shape({
            risques: Yup.object()
                .shape({
                    sante: Yup.boolean(),
                    prevoyance: Yup.boolean(),
                })
                .test({
                    message: t('yup.validators.risques'),
                    test: (objects: any) => {
                        if (!objects) return false;
                        const values = Object.values(objects);
                        return values.includes(true);
                    },
                }),
            souscripteurs: Yup.array()
                .of(
                    Yup.object().shape({
                        value: Yup.string().required(),
                        label: Yup.string().required(),
                    }),
                )
                .test({
                    message: t('yup.validators.required'),
                    test: (objects: any) => {
                        return objects?.length ? true : false;
                    },
                }),
            colleges: Yup.array()
                .of(
                    Yup.object().shape({
                        value: Yup.string().required(),
                        label: Yup.string().required(),
                    }),
                )
                .test({
                    message: t('yup.validators.required'),
                    test: (objects: any) => {
                        return objects?.length ? true : false;
                    },
                }),
        }),
    });

    /** USEFORM */

    const initStatsForm: StatsForm = {
        dateArrete: format(new Date(), 'yyyy/MM/dd'),
        perimetre: {
            risques: { sante: true, prevoyance: false },
            souscripteurs: [],
            colleges: [],
        },
    };

    //* UseForm initialisation
    const methods = useForm<StatsForm>({
        resolver: yupResolver(validationSchema),
        defaultValues: {},
    });

    //* UseForm reset
    useEffect(
        () => {
            reset({ ...initStatsForm });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    //* UseForm method destructuration
    const {
        handleSubmit,
        reset,
        setValue,
        trigger,
        formState: { errors, isDirty },
    } = methods;

    /** CONTROLLED FORM */

    //* Controlled form initialisation + init useForm called
    const initFormControlled = (initStatsForm: StatsForm) => {
        // Perimetre
        setSante(true);
        setPrevoyance(initStatsForm.perimetre.risques.prevoyance);
        setSelectedColleges(initStatsForm.perimetre.colleges);
        setSelectedSouscrips(initStatsForm.perimetre.souscripteurs);

        reset({ ...initStatsForm });

        // init useForm
        //setSelectedUser({ ...initStatsForm });
    };

    useEffect(() => {
        initFormControlled({ ...initStatsForm });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const apiCalls = async (payload) => {
        await Promise.all([
            statisticsService
                .getPyramidAge({
                    colleges: payload.colleges,
                    souscripteurs: payload.souscripteurs,
                    dateArrete: payload.dateArrete,
                })
                .then((response: any) => response),

            statisticsService
                .getChoixAdhesion({
                    colleges: payload.colleges,
                    souscripteurs: payload.souscripteurs,
                    dateArrete: payload.dateArrete,
                })
                .then((response: any) => response),
            // statisticsService
            //     .getFraisReels({
            //         colleges: payload.colleges,
            //         souscripteurs: payload.souscripteurs,
            //         dateArrete: payload.dateArrete,
            //     })
            //     .then((response: any) => response),
            statisticsService
                .getEffectifEnPortabilite({
                    colleges: payload.colleges,
                    souscripteurs: payload.souscripteurs,
                    dateArrete: payload.dateArrete,
                })
                .then((response: any) => response),
            statisticsService
                .getEffectifsMoyens({
                    colleges: payload.colleges,
                    souscripteurs: payload.souscripteurs,
                    dateArrete: payload.dateArrete,
                })
                .then((response: any) => response),
        ]).then(([pyramideAge, ChoixAdhesion, EffectifEnPortabilite, effectifMoyen]) => {
            handlePyramidAge(pyramideAge);
            handleEffectifMoyen(effectifMoyen);
            handleChoixAdhesion(ChoixAdhesion);
            //handleFraisReels(fraisReels);
            handleEffectifEnPortabilite(EffectifEnPortabilite);
        });
    };

    const handleSendForm = async (data: StatsForm) => {
        if (!(await validateStep(activeStep))) return false;
        setIsFormSubmitted(true);
        let payload = {
            dateArrete: data['dateArrete'],
            souscripteurs: data.perimetre['souscripteurs'].map((e) => e.value),
            colleges: data.perimetre['colleges'].map((e) => e.value),
        };
        setCompleted({ 0: true, 1: true });
        await apiCalls(payload)
            .then(() => {
                handleComplete();
                setIsFormSubmitted(false);
            })
            .catch(() => {
                setIsFormSubmitted(false);
                alert('Une erreur est survenue');
            });
    };

    const hasNoContract = (data: any) => {
        return data?.length === 0 ? true : false;
    };

    return (
        <>
            <Container>
                <Card>
                    <Box sx={{ width: '100%', height: '100%' }} className="p-4">
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label, index) => (
                                <Step key={label} completed={completed[index]}>
                                    <StepButton color="inherit" onClick={handleStep(index)}>
                                        <Typography component={'h1'}>{label}</Typography>
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>

                        <React.Fragment>
                            {activeStep === 0 && (
                                <>
                                    <Grid container spacing={2} direction="row" justify="flex-start" alignItems="flex-start">
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={8} className={'text-center pl-5 pr-5 mt-2'}>
                                            <Typography className="">
                                                Bienvenue dans votre espace statistiques. Une fois votre périmètre sélectionné, retrouvez dans cette rubrique vos données (dernière actualisation 48h
                                                avant)
                                            </Typography>
                                            {hasNoContract(data) && (
                                                <Box className="mt-3">
                                                    <Alert severity="warning">En raison de l'absence d'un contrat d'assurance santé, vous ne serez pas en mesure de générer un rapport</Alert>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item xs={2}></Grid>
                                    </Grid>
                                    <FormProvider {...methods}>
                                        <SGSForm.Card onSubmit={handleSubmit(handleSendForm)} shadow={false}>
                                            {/* <Typography
                                                component={'h1'}
                                                className={`mb-2 ${errors.risques ? styles.msgError : ''}`}
                                            >
                                                Date d'arrêté du rapport
                                            </Typography>
                                            <SGSForm.Row>
                                                <SGSForm.Col md={4}>
                                                    <Box component={'span'} className="ml-3">
                                                        <SGSDatepickerCtrl
                                                            name={'dateArrete'}
                                                            label="Date d'arrêté"
                                                            setValue={setValue}
                                                        />
                                                    </Box>
                                                </SGSForm.Col>
                                            </SGSForm.Row> */}
                                            <FormPerimetre setValue={setValue} errors={errors} trigger={trigger} displayRisk={false} displayExcludeVIP={false}></FormPerimetre>
                                        </SGSForm.Card>
                                    </FormProvider>
                                </>
                            )}
                            {activeStep === 1 && (
                                <Grid container spacing={2} direction="row" justify="flex-start" alignItems="flex-start">
                                    {/* <Grid item xs={3} className={'text-center'}>
                                        <Box className="mt-5">
                                            <SGSButton onClick={handleBack}>Nouveau rapport</SGSButton>
                                        </Box>
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <TableEffectifsMoyens />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <PyramideAge />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ChoixAdhesion />
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <FraisReels metric={'pourcentage'} />
                                    </Grid> */}
                                    <Grid item xs={6}>
                                        <EffectifEnPortabilite />
                                    </Grid>
                                </Grid>
                            )}
                            <FormProvider {...methods}>
                                <SGSForm.Card onSubmit={handleSubmit(handleSendForm)} shadow={false}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} className="mb-4">
                                        <Box sx={{ flex: '1 1 auto' }} />
                                        {activeStep !== 0 && (
                                            <SGSButton disabled={activeStep === 0} onClick={handleBack}>
                                                Nouveau rapport
                                            </SGSButton>
                                        )}
                                        {activeStep === 0 && (
                                            <Box sx={{ flex: '1 1 auto' }} className="text-right mr-3">
                                                <SGSButton type="button" onClick={() => handleFormCancel()} disabled={!isDirty ? true : false}>
                                                    {t('global.cancel')}
                                                </SGSButton>
                                            </Box>
                                        )}
                                        {activeStep === 0 && (
                                            <>
                                                <Box sx={{ flex: '1 1 auto' }} className="text-left mr-3">
                                                    <SGSButton type="submit" loading={isFormSubmitted}>
                                                        {t('statistics.form.generateReport')}
                                                    </SGSButton>
                                                </Box>
                                            </>
                                        )}
                                        <Box sx={{ flex: '1 1 auto' }} />
                                    </Box>
                                </SGSForm.Card>
                            </FormProvider>
                        </React.Fragment>
                    </Box>
                </Card>
            </Container>
        </>
    );
};

export default Dashboard;
